<div class="tab-container" #sourceListContainer>
  <div class="ft-form-row">
    <span class="title">{{ title }}</span>
  </div>

  <div class="ft-form-row col1-v100">
    <div class="ft-form-input">
      <div class="icon-input-container">
        <input id="place-editor-search" class="icon-input" placeholder="{{ 'ph_search_source' | translate }}" type="text"
          [(ngModel)]="searchPhrase" />
        <div class="icon-input-wrap">
          <img src="/assets/images/icons/search.svg" width="30" height="30" />
        </div>
      </div>
    </div>
  </div>

  <div class="place-wrapper">
    <div class="tab-forms">
      <div id="place-content">
        <div class="ft-form" *ngIf="placeL?.length == 0 || placeL == null">
          <div class="ft-form-row no-record-row">
            <div id="place-editor-no-places" class="no-record">
              <span>{{ "lbl_no_place" | translate }}</span>
            </div>
          </div>
        </div>

        <div id="place-list-container" #placeListContainer *ngIf="placeL?.length > 0">
          <div *ngFor="let place of filteredPlaces" class="item place-list-item" 
          [ngClass]="{ 'highlighted-place': editedPlaceId === place.id }">

            <div class="item-image" style="background-color: #e6eed7;">
              <img [src]="getTimeStampedImageUrl(place?.mediaUrl)" (error)="onImageLoadingError($event)">
            </div>

            <div class="item-content">
              <span class="place-list-item-name label-m-grey text-ellipsis-1">{{ place.rawData }}</span>
              <span class="place-list-item-used label-s-grey text-ellipsis-1">({{ place.used }}x)</span>
            </div>

            <div class="item-options">
              <img src="/assets/images/icons/edit.svg" class="place-list-item-edit ft-btn-round-green-base" width="23" height="23"
                (click)="editPlace(place)" />
              <img src="/assets/images/icons/delete.svg" class="place-list-item-delete ft-btn-round-green-base" width="23" height="23"
                (click)="deletePlace(place)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>